import React, { useState, useReducer, useEffect } from 'react'
import * as yup from "yup"
import { Form, Formik } from 'formik';
import Modal from 'react-bootstrap/Modal';
import { formInitialState, formReducer } from '../../../../../reducers/formReducer';
import FormErrorMessage from '../../../../UI/errorMessages/FormErrorMessage';
import CMSFormTextArea from '../../../../UI/forms/CMSFormTextArea';
import { Alert, Button, Card, Col, Row } from 'react-bootstrap';
import axios from "../../../../../config/axios";
import { Store as toast } from 'react-notifications-component';
import { toastNotification } from '../../../../../config/toastNotification'
import CMSFormInput from '../../../../UI/forms/CMSFormInput';
import CMSFormCheckBoxes from '../../../../UI/forms/CMSFormCheckBoxes';
import { checkPartnerStatus, checkStatus, didCapacityReached, getFullName, getRemainingGuestCount, getRemainingKidsCount } from '../../../../../helpers/CommonHelper';
import ModuleDisplayDate from '../../../../UI/modules/fieldsDisplay/ModuleDisplayDate';

import CMSFormSwitch from '../../../../UI/forms/CMSFormSwitch';
import CMSFormSelect from '../../../../UI/forms/CMSFormSelect';
import { Link } from 'react-router-dom';


export const AddMoreParticipantsModal = ({ show, setShow, loadItems, id, data }) => {
    const [formState, formDispatch] = useReducer(formReducer, formInitialState)
    const [screen, setScreen] = useState({
        loading: true,
        status: "fetching",
        activityStatus: "fetching",
        members: null,
        item: null
    });
    console.log(data)
    const handleClose = (resetForm) => {
        resetForm();  // Reset form values
        setShow(false);
    };
    const handleShow = () => setShow(true);
    const calculateTotalValue = (values, item) => {
        let total = 0;



        if (values.partnerParticipating === "1" && item.partnerFeaturesSettings?.paidParticipation === "1") {
            total += item.partnerFeaturesSettings.participationFee;
        }

        if (values.guestParticipating === "1" && item.guestFeaturesSettings?.paidParticipation === "1") {
            total += item.guestFeaturesSettings.participationFee * values.NumberOfGuestParticipating;
        }

        if (values.kidsParticipating === "1" && item.kidsFeaturesSettings?.paidParticipation === "1") {
            total += item.kidsFeaturesSettings.participationFee * values.NumberOfKidsParticipating;
        }

        return total;
    };
    const generateOptionsArray = (num) => {
        const parsedNum = Number(num);
        if (isNaN(parsedNum) || parsedNum < 1) {
            return [];
        }

        return Array.from({ length: Math.floor(parsedNum) }, (_, i) => ({
            label: `${i + 1}`,
            value: i + 1
        }));
    };
    const loadMembersListForRegistration = async () => {
        setScreen((prevState) => ({
            ...prevState,
            loading: true,
        }));

        try {
            const res = await axios.get(`members`); //
            console.log(res.status)
            if (res && res.status) {
                setScreen((prevState) => ({
                    ...prevState,
                    loading: false,
                    status: "fetched",
                    members: res.data?.items
                }));
            }

        } catch (error) {
            setScreen((prevState) => ({
                ...prevState,
                loading: false,
                status: "fetchError"
            }));
        }
    }


    const onSubmit = async (data, { resetForm }) => {

        formDispatch({
            type: "FORM_SUBMISSION_REQUEST"
        });

        try {
            const res = await axios.post(`activity-registrations/registration-additional-request`, data);
            formDispatch({
                type: "FORM_SUBMISSION_SUCCESS",
                payload: res.data
            });
            handleClose(resetForm)
            toast.addNotification({
                ...toastNotification,
                title: "Success!",
                message: `Action done successfully.`,
                type: "success",
            });
            resetForm();
            formDispatch({
                type: "FORM_INITIAL_STAGE"
            });
            loadItems()
        } catch (error) {
            formDispatch({
                type: "FORM_SUBMISSION_FAILED",
                payload: error
            });
            toast.addNotification({
                ...toastNotification,
                title: "Alert!",
                message: `Action failed, try again later.`,
                type: "danger",
            });
            setTimeout(() => {
                formDispatch({
                    type: "FORM_INITIAL_STAGE"
                });
            }, 5000)
        }
    }

    const getValidationSchema = () => {
        return yup.object({
            memberId: yup.string().required("Please select a member"),
            partnerParticipating: yup.string(),
            guestParticipating: yup.string(),
            kidsParticipating: yup.string(),
            NumberOfGuestParticipating: yup.string(),
            NumberOfKidsParticipating: yup.string(),

        })
    }

    const getInitialValues = () => {

        let returnObj = {
            memberId: data.memberId,
            registrationId: data._id,
            activityId: id,
            partnerParticipating: "0",
            guestParticipating: "0",
            NumberOfGuestParticipating: 1,
            kidsParticipating: "0",
            NumberOfKidsParticipating: 1,
            notes: "",
        }
        return returnObj;
    }
    const transformArray = (data) => {
        return [
            { label: "Select an option", value: "" }, // Placeholder option
            ...data.map(item => ({
                label: item.fullName,
                value: item._id
            }))
        ];
    };
    const loadItem = async () => {
        if (id) {
            try {
                const res = await axios.get(`activities/${id}`); //
                if (res && (res.status === 200 || res.status === 201)) {
                    setScreen((prevState) => ({
                        ...prevState,
                        loading: false,
                        activityStatus: "fetched",
                        item: res.data?.item
                    }));
                }

            } catch (error) {
                setScreen((prevState) => ({
                    ...prevState,
                    loading: false,
                    activityStatus: "fetchError",

                }));
            }
        }
    };

    useEffect(() => {
        loadItem();
        loadMembersListForRegistration();
    }, [])

    return (

        <>

            {screen.item != null && data &&
                <Formik
                    initialValues={getInitialValues()}
                    validationSchema={getValidationSchema()}
                    enableReinitialize={true}
                    validateOnChange={true}
                    validateOnBlur={true}
                    onSubmit={async (values, { resetForm }) => {
                        if (values.guestParticipating === "0") {
                            values.NumberOfGuestParticipating = 0
                        }
                        if (values.kidsParticipating === "0") {
                            values.NumberOfKidsParticipating = 0
                        }
                        console.log(values);
                        function areParticipationValuesZero(registration) {
                            return (
                                registration?.partnerParticipating === "0" &&
                                registration?.guestParticipating === "0" &&
                                registration?.NumberOfGuestParticipating === 0 &&
                                registration?.kidsParticipating === "0" &&
                                registration?.NumberOfKidsParticipating === 0
                            );
                        }
                        if (areParticipationValuesZero(values)) {
                            toast.addNotification({
                                ...toastNotification,
                                title: "Error!",
                                message: `Please select a participant.`,
                                type: "danger",
                            });
                        }
                        else {
                            onSubmit(values, { resetForm })
                        }
                        //onSubmit(values, { resetForm })
                    }}
                >
                    {(form) => (

                        <Modal className={(((screen.item.guestFeaturesSettings?.allowed === "1" || screen.item.kidsFeaturesSettings.allowed === "1") && (getRemainingGuestCount(screen.item, data) > 0 || getRemainingKidsCount(screen.item, data) > 0))) ? 'acceptModal' : ""} show={show} onHide={() => handleClose(form.resetForm)}>
                            {(formState.isFormSubmitting) && <div class="overlay">
                                <i class="fas fa-2x fa-sync-alt text-white fa-spin"></i>
                            </div>}
                            {/* {(formState.isFormSubmitting) && <ContainerLoading />} */}
                            <Form onSubmit={form.handleSubmit}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Register</Modal.Title>
                                </Modal.Header>
                                {screen.status === "fetched" && screen.item &&
                                    <>
                                        <Modal.Body className={didCapacityReached(screen.item) ? "p-1" : "p-2"}>
                                            {(formState.hasSubmissionError) &&
                                                <FormErrorMessage error={formState.formSubmissionError} />
                                            }
                                            <Row className='w-100 mx-auto mt-0'>
                                                {didCapacityReached(screen.item) && <>
                                                    <Col xl={12} lg={12} md={12} sm={12} xs={12} className='mb-1'>
                                                        <div className="alertNotApplicable red fontItalic m-0  py-2">
                                                            Registrations reached maximum capacity.
                                                            <span>
                                                                <a href={`/activities/update/${id}`} className="increase-capacity-link">
                                                                    <span className="increase-capacity-text">
                                                                        Click to Increase Capacity
                                                                    </span>
                                                                </a>
                                                            </span>
                                                        </div>
                                                    </Col>
                                                </>}
                                                <>
                                                    <Col xl={12} lg={12} md={12} sm={12} xs={12} className=''>
                                                        {
                                                            ((screen.item.partnerFeaturesSettings && screen.item.partnerFeaturesSettings.allowed === "0") ||
                                                                (screen.item.guestFeaturesSettings && screen.item.guestFeaturesSettings.allowed === "0") ||
                                                                (screen.item.kidsFeaturesSettings && screen.item.kidsFeaturesSettings.allowed === "0")
                                                            ) && (
                                                                <div className="alertNotApplicable yellow fontItalic m-0 mb-3 py-3">
                                                                    {screen.item.paidActivity === "1" && screen.item.participationFee > 0 &&
                                                                        <p className='participationFeeDisplay top mb-1'>Participation fee for member is <b>{screen.item.participationFee} AED</b></p>}
                                                                    {screen.item.paidActivity === "0" &&
                                                                        <p className='participationFeeDisplay text-success top mb-2'>Participation is free for member</p>}
                                                                    {
                                                                        (screen.item.partnerFeaturesSettings && screen.item.partnerFeaturesSettings.allowed === "0")
                                                                            ? <p className='mb-0 '>Partner participation is not allowed</p>

                                                                            : null
                                                                    }
                                                                    {
                                                                        (screen.item.guestFeaturesSettings && screen.item.guestFeaturesSettings.allowed === "0")
                                                                            ? <p className='mb-0 '>Guest participation is not allowed</p>

                                                                            : null
                                                                    }

                                                                    {
                                                                        (screen.item.kidsFeaturesSettings && screen.item.kidsFeaturesSettings.allowed === "0")
                                                                            ? <p className='mb-0 '>Kids participation is not allowed.</p>

                                                                            : null
                                                                    }

                                                                </div>
                                                            )
                                                        }

                                                    </Col>
                                                    <Col xl={(screen.item.guestFeaturesSettings?.allowed === "1" || screen.item.kidsFeaturesSettings.allowed === "1") && (getRemainingGuestCount(screen.item, data) > 0 || getRemainingKidsCount(screen.item, data) > 0) ? 6 : 12} lg={(screen.item.guestFeaturesSettings?.allowed === "1" || screen.item.kidsFeaturesSettings.allowed === "1") && (getRemainingGuestCount(screen.item, data) > 0 || getRemainingKidsCount(screen.item, data) > 0) ? 6 : 12} md={12} sm={12} xs={12}>
                                                        <div className='mt-2 px-3'>
                                                            {/* {(screen.item.partnerFeaturesSettings && screen.item.partnerFeaturesSettings.allowed === "1") &&
                                                                (screen.item.guestFeaturesSettings && screen.item.guestFeaturesSettings.allowed === "1") &&
                                                                (screen.item.kidsFeaturesSettings && screen.item.kidsFeaturesSettings.allowed === "1")
                                                                && screen.item.paidActivity === "1" && screen.item.participationFee > 0 &&
                                                                <p className='participationFeeDisplay top mb-3'>Participation fee for member is <b>{screen.item.participationFee} AED</b></p>}
                                                            {(screen.item.partnerFeaturesSettings && screen.item.partnerFeaturesSettings.allowed === "1") &&
                                                                (screen.item.guestFeaturesSettings && screen.item.guestFeaturesSettings.allowed === "1") &&
                                                                (screen.item.kidsFeaturesSettings && screen.item.kidsFeaturesSettings.allowed === "1")
                                                                && screen.item.paidActivity === "0" &&
                                                                <p className='participationFeeDisplay text-success top mb-3'>Participation is free for member</p>} */}
                                                            <CMSFormSelect
                                                                name="memberId"
                                                                label="Select Member"
                                                                required={true}
                                                                form={form}
                                                                disabled
                                                                options={[
                                                                    {
                                                                        label:data.member.fullName,
                                                                        value:data.member._id
                                                                    }
                                                                ]}
                                                            />
                                                            {
                                                                !checkStatus(data, 'partnerStatus') && (screen.item.partnerFeaturesSettings && screen.item.partnerFeaturesSettings.allowed === "1")
                                                                    ? <div className={screen.item.guestFeaturesSettings?.allowed === "1" || screen.item.kidsFeaturesSettings.allowed === "1" ? ' pt-0' : "pt-0"}>
                                                                        <CMSFormSwitch
                                                                            name="partnerParticipating"
                                                                            label="Partner Participating?"
                                                                            initialValue={(getInitialValues().partnerParticipating === "1") ? true : false}
                                                                            onChange={(value) => form.setFieldValue("partnerParticipating", value ? "1" : "0")}

                                                                        />
                                                                        {screen.item.partnerFeaturesSettings && screen.item.partnerFeaturesSettings.paidParticipation === "1" &&
                                                                            <p className='participationFeeDisplay mb-3'>Participation fee for partner is <b>{screen.item.partnerFeaturesSettings.participationFee} AED</b></p>}
                                                                        {screen.item.partnerFeaturesSettings && screen.item.partnerFeaturesSettings.paidParticipation === "0" &&
                                                                            <p className='participationFeeDisplay text-success mb-3'>Participation is free for partner</p>}
                                                                    </div>
                                                                    : null
                                                            }
                                                            <CMSFormTextArea
                                                                name="notes"
                                                                label="Notes For Admin Records"
                                                                form={form}
                                                                required={false}
                                                            />

                                                        </div>
                                                    </Col>
                                                    {(screen.item.guestFeaturesSettings?.allowed === "1" || screen.item.kidsFeaturesSettings.allowed === "1") &&
                                                        <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                                            <div className='mt-1 px-3'>
                                                                {getRemainingGuestCount(screen.item, data) > 0 &&
                                                                    (screen.item.guestFeaturesSettings && screen.item.guestFeaturesSettings.allowed === "1")
                                                                    ? <div className={screen.item.kidsFeaturesSettings.allowed === "1" ? 'border-bottom pt-2' : "pt-0"}> <CMSFormSwitch
                                                                        name="guestParticipating"
                                                                        label="Guest Participating?"
                                                                        onChange={(value) => form.setFieldValue("guestParticipating", value ? "1" : "0")}
                                                                        initialValue={(getInitialValues().guestParticipating === "1") ? true : false}

                                                                    />
                                                                        {screen.item.guestFeaturesSettings && screen.item.guestFeaturesSettings.paidParticipation === "1" &&
                                                                            <p className='participationFeeDisplay mb-3'> Participation fee per guest is <b>{screen.item.guestFeaturesSettings.participationFee} AED</b></p>}
                                                                        {screen.item.guestFeaturesSettings && screen.item.guestFeaturesSettings.paidParticipation === "0" &&
                                                                            <p className='participationFeeDisplay  text-success mb-3'> Participation is free for guest(s)</p>}
                                                                        {(form.values.guestParticipating === "1" || form.values.guestParticipating === true) &&
                                                                            <CMSFormSelect
                                                                                name="NumberOfGuestParticipating"
                                                                                label="Number Of Guest Participating"
                                                                                required={true}
                                                                                form={form}
                                                                                options={generateOptionsArray(getRemainingGuestCount(screen.item, data))}
                                                                            />}
                                                                    </div>
                                                                    : null
                                                                }
                                                                {getRemainingKidsCount(screen.item, data) > 0 &&
                                                                    (screen.item.kidsFeaturesSettings && screen.item.kidsFeaturesSettings.allowed === "1")
                                                                    ? <div className="pt-2"> <CMSFormSwitch
                                                                        name="kidsParticipating"
                                                                        label="Kids Participating?"
                                                                        initialValue={(getInitialValues().kidsParticipating === "1") ? true : false}
                                                                        onChange={(value) => form.setFieldValue("kidsParticipating", value ? "1" : "0")}
                                                                    />
                                                                        {screen.item.kidsFeaturesSettings && screen.item.kidsFeaturesSettings.paidParticipation === "1" &&
                                                                            <p className='participationFeeDisplay mb-3'>Participation fee per kid is <b>{screen.item.kidsFeaturesSettings.participationFee} AED</b></p>}
                                                                        {screen.item.kidsFeaturesSettings && screen.item.kidsFeaturesSettings.paidParticipation === "0" &&
                                                                            <p className='participationFeeDisplay text-success mb-3'>Participation is free for kid(s)</p>}
                                                                        {(form.values.kidsParticipating === "1" || form.values.kidsParticipating === true) &&
                                                                            <CMSFormSelect
                                                                                name="NumberOfKidsParticipating"
                                                                                label="Number Of Kids Participating"
                                                                                required={true}
                                                                                form={form}
                                                                                options={generateOptionsArray(getRemainingKidsCount(screen.item, data))}
                                                                            />}
                                                                    </div>
                                                                    : null
                                                                }

                                                            </div>
                                                        </Col>}
                                                    {/* {(screen.item.partnerFeaturesSettings?.allowed === "1" || screen.item.guestFeaturesSettings?.allowed === "1" || screen.item.kidsFeaturesSettings.allowed === "1") &&
                                                        <Col xl={(screen.item.guestFeaturesSettings?.allowed === "0" && screen.item.kidsFeaturesSettings.allowed === "0") ? 12 : 5}
                                                            lg={(screen.item.guestFeaturesSettings?.allowed === "0" && screen.item.kidsFeaturesSettings.allowed === "0") ? 12 : 5}
                                                            md={(screen.item.guestFeaturesSettings?.allowed === "0" && screen.item.kidsFeaturesSettings.allowed === "0") ? 12 : 5}
                                                            sm={(screen.item.guestFeaturesSettings?.allowed === "0" && screen.item.kidsFeaturesSettings.allowed === "0") ? 12 : 12}
                                                            xs={12}
                                                            className='d-flex flex-column justify-content-start me-4 '>

                                                            <div className='mt-2'>



                                                                {
                                                                    !checkStatus(data, 'partnerStatus') && (screen.item.partnerFeaturesSettings && screen.item.partnerFeaturesSettings.allowed === "1")
                                                                        ? <div className={screen.item.guestFeaturesSettings?.allowed === "1" || screen.item.kidsFeaturesSettings.allowed === "1" ? 'border-bottom pt-0' : "pt-0"}>
                                                                            <CMSFormSwitch
                                                                                name="partnerParticipating"
                                                                                label="Partner Participating?"
                                                                                initialValue={(getInitialValues().partnerParticipating === "1") ? true : false}
                                                                                onChange={(value) => form.setFieldValue("partnerParticipating", value ? "1" : "0")}

                                                                            />
                                                                            {screen.item.partnerFeaturesSettings && screen.item.partnerFeaturesSettings.paidParticipation === "1" &&
                                                                                <p className='participationFeeDisplay mb-3'>Participation fee for partner is <b>{screen.item.partnerFeaturesSettings.participationFee} AED</b></p>}
                                                                            {screen.item.partnerFeaturesSettings && screen.item.partnerFeaturesSettings.paidParticipation === "0" &&
                                                                                <p className='participationFeeDisplay text-success mb-3'>Participation is free for partner</p>}
                                                                        </div>
                                                                        : null
                                                                }

                                                                {getRemainingGuestCount(screen.item, data) > 0 &&
                                                                    (screen.item.guestFeaturesSettings && screen.item.guestFeaturesSettings.allowed === "1")
                                                                    ? <div className={screen.item.kidsFeaturesSettings.allowed === "1" ? 'border-bottom pt-2' : "pt-0"}> <CMSFormSwitch
                                                                        name="guestParticipating"
                                                                        label="Guest Participating?"
                                                                        onChange={(value) => form.setFieldValue("guestParticipating", value ? "1" : "0")}
                                                                        initialValue={(getInitialValues().guestParticipating === "1") ? true : false}

                                                                    />
                                                                        {screen.item.guestFeaturesSettings && screen.item.guestFeaturesSettings.paidParticipation === "1" &&
                                                                            <p className='participationFeeDisplay mb-3'> Participation fee per guest is <b>{screen.item.guestFeaturesSettings.participationFee} AED</b></p>}
                                                                        {screen.item.guestFeaturesSettings && screen.item.guestFeaturesSettings.paidParticipation === "0" &&
                                                                            <p className='participationFeeDisplay  text-success mb-3'> Participation is free for guest(s)</p>}
                                                                        {(form.values.guestParticipating === "1" || form.values.guestParticipating === true) &&
                                                                            <CMSFormSelect
                                                                                name="NumberOfGuestParticipating"
                                                                                label="Number Of Guest Participating"
                                                                                required={true}
                                                                                form={form}
                                                                                options={generateOptionsArray(getRemainingGuestCount(screen.item, data))}
                                                                            />}
                                                                    </div>
                                                                    : null
                                                                }
                                                                {getRemainingKidsCount(screen.item, data) > 0 &&
                                                                    (screen.item.kidsFeaturesSettings && screen.item.kidsFeaturesSettings.allowed === "1")
                                                                    ? <div className="pt-2"> <CMSFormSwitch
                                                                        name="kidsParticipating"
                                                                        label="Kids Participating?"
                                                                        initialValue={(getInitialValues().kidsParticipating === "1") ? true : false}
                                                                        onChange={(value) => form.setFieldValue("kidsParticipating", value ? "1" : "0")}
                                                                    />
                                                                        {screen.item.kidsFeaturesSettings && screen.item.kidsFeaturesSettings.paidParticipation === "1" &&
                                                                            <p className='participationFeeDisplay mb-3'>Participation fee per kid is <b>{screen.item.kidsFeaturesSettings.participationFee} AED</b></p>}
                                                                        {screen.item.kidsFeaturesSettings && screen.item.kidsFeaturesSettings.paidParticipation === "0" &&
                                                                            <p className='participationFeeDisplay text-success mb-3'>Participation is free for kid(s)</p>}
                                                                        {(form.values.kidsParticipating === "1" || form.values.kidsParticipating === true) &&
                                                                            <CMSFormSelect
                                                                                name="NumberOfKidsParticipating"
                                                                                label="Number Of Kids Participating"
                                                                                required={true}
                                                                                form={form}
                                                                                options={generateOptionsArray(getRemainingKidsCount(screen.item, data))}
                                                                            />}
                                                                    </div>
                                                                    : null
                                                                }
                                                            </div>
                                                        </Col>} */}
                                                    {/* <Col >
                                                        <CMSFormSelect
                                                            name="memberId"
                                                            label="Select Member"
                                                            required={true}
                                                            form={form}
                                                            disabled
                                                            options={transformArray(screen.members)}
                                                        />
                                                        <CMSFormTextArea
                                                            name="notes"
                                                            label="Notes For Admin Records"
                                                            form={form}
                                                            required={false}
                                                        />

                                                    </Col> */}
                                                    <Col xl={12} lg={12} md={12} sm={12} xs={12} className='border-top pt-3 mt-2 mb-2'>
                                                        <div className='d-flex align-items-center justify-content-end totalAmountDisplay'>
                                                            <p className='d-flex mb-0'>Total Amount: <h5 className='mb-0 mx-2'>{calculateTotalValue(form.values, screen.item)} AED</h5></p>
                                                        </div>
                                                    </Col>
                                                </>
                                            </Row>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={() => handleClose(form.resetForm)}>
                                                Close
                                            </Button>
                                            <Button variant="primary" type="submit">
                                                Submit
                                            </Button>
                                        </Modal.Footer>
                                    </>}
                                {screen.status === "fetchError" && <Alert variant='danger' className='mb-0'>Something went wrong! Try again later.</Alert>}
                            </Form>


                        </Modal>

                    )}
                </Formik>
            }
        </>

    )
}
